var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1135",
    "data-name": "Group 1135",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    "data-name": "Rectangle 420",
    width: 20,
    height: 20,
    fill: "#15345a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-apps",
    transform: "translate(2 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M5.833,0h-2.5A3.333,3.333,0,0,0,0,3.333v2.5A3.333,3.333,0,0,0,3.333,9.167h2.5A3.333,3.333,0,0,0,9.167,5.833v-2.5A3.333,3.333,0,0,0,5.833,0ZM7.5,5.833A1.667,1.667,0,0,1,5.833,7.5h-2.5A1.667,1.667,0,0,1,1.667,5.833v-2.5A1.667,1.667,0,0,1,3.333,1.667h2.5A1.667,1.667,0,0,1,7.5,3.333Z",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M18.833,0h-2.5A3.333,3.333,0,0,0,13,3.333v2.5a3.333,3.333,0,0,0,3.333,3.333h2.5a3.333,3.333,0,0,0,3.333-3.333v-2.5A3.333,3.333,0,0,0,18.833,0ZM20.5,5.833A1.667,1.667,0,0,1,18.833,7.5h-2.5a1.667,1.667,0,0,1-1.667-1.667v-2.5a1.667,1.667,0,0,1,1.667-1.667h2.5A1.667,1.667,0,0,1,20.5,3.333Z",
    transform: "translate(-2.167)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M5.833,13h-2.5A3.333,3.333,0,0,0,0,16.333v2.5a3.333,3.333,0,0,0,3.333,3.333h2.5a3.333,3.333,0,0,0,3.333-3.333v-2.5A3.333,3.333,0,0,0,5.833,13ZM7.5,18.833A1.667,1.667,0,0,1,5.833,20.5h-2.5a1.667,1.667,0,0,1-1.667-1.667v-2.5a1.667,1.667,0,0,1,1.667-1.667h2.5A1.667,1.667,0,0,1,7.5,16.333Z",
    transform: "translate(0 -2.167)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M18.833,13h-2.5A3.333,3.333,0,0,0,13,16.333v2.5a3.333,3.333,0,0,0,3.333,3.333h2.5a3.333,3.333,0,0,0,3.333-3.333v-2.5A3.333,3.333,0,0,0,18.833,13ZM20.5,18.833A1.667,1.667,0,0,1,18.833,20.5h-2.5a1.667,1.667,0,0,1-1.667-1.667v-2.5a1.667,1.667,0,0,1,1.667-1.667h2.5A1.667,1.667,0,0,1,20.5,16.333Z",
    transform: "translate(-2.167 -2.167)",
    fill: "#15345a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenu);
export default __webpack_public_path__ + "static/media/mobileMenu.1939d13c8d81bb25724ab57a3e4f60fa.svg";
export { ForwardRef as ReactComponent };